module.exports = __webpack_public_path__ + "img/制御工学4_9.ea780778.png";